import React, { useEffect } from 'react';
import {
  Navigate,
  Outlet,
  useLocation,
  useParams,
  useResolvedPath,
} from 'react-router-dom';
import {
  SchoolSchoolyearProvider,
  useSchoolSchoolyear,
} from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { useCurrentSchoolyearIdSchoolId } from '@teetsh/app/src/queries/schoolyears/atom';
import { useSetSkipBookmarkWarning } from 'containers/BookmarkToPastYearMessage';

export function SchoolyearProviderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const params = useParams<{
    schoolyearId: string;
    schoolId: string;
  }>();
  const schoolyearId = params.schoolyearId as string;
  const schoolId = params.schoolId as string;

  const { setCurrentSchoolyearIdSchoolId } = useCurrentSchoolyearIdSchoolId();
  useEffect(() => {
    setCurrentSchoolyearIdSchoolId({
      schoolyearId,
      schoolId,
    });
  }, [schoolyearId, schoolId]);
  return (
    <SchoolSchoolyearProvider schoolId={schoolId} schoolyearId={schoolyearId}>
      {children}
    </SchoolSchoolyearProvider>
  );
}

export function RedirectToSchoolyearRoute() {
  const pathSuffix = useResolvedPath('').pathname;
  const { search } = useLocation();
  const { school, schoolyear } = useSchoolSchoolyear();
  const ignoreBookmarkWarning = useSetSkipBookmarkWarning();

  // we don't want to warn the user if he navigates throught a redirect
  // we only want to warn him if it looks like a direct access using a bookmark
  ignoreBookmarkWarning(true);

  return (
    <Navigate
      to={{
        pathname: `/annee-scolaire/${schoolyear.id}/ecole/${school.id}${pathSuffix}`,
        search,
      }}
      replace
    />
  );
}

export function RedirectToSchoolyearsRoute() {
  const { currentSchoolId, currentSchoolyearId } =
    useCurrentSchoolyearIdSchoolId();
  return (
    <SchoolSchoolyearProvider
      schoolyearId={currentSchoolyearId}
      schoolId={currentSchoolId}
    >
      <Outlet />
    </SchoolSchoolyearProvider>
  );
}
